import { GET_NEW_TRADE_PAIR,GET_NEW_TRADE_PAIR_ERROR,GET_NEW_TRADE_PAIR_REQUEST,UPDATE_NEW_TRADE_PAIR_DATA,REMOVE_NEW_TRADE_PAIR} from "../../ActionTypes/ActionTypes.js";

const initialState = {
    newTradePairLoading: false,
    newTradePairData: null,
    newTradePairError: null,
    newTradePairStatus: null,
    isModified: false,
    isFirstLoad: true,


};

const NewTradePairReducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_NEW_TRADE_PAIR_REQUEST:
            return { ...state, newTradePairLoading: true, newTradePairStatus: null, tradePairData: null };
        case GET_NEW_TRADE_PAIR:
            return {
                newTradePairLoading: false, newTradePairData: action.payload, newTradePairError: null, newTradePairStatus: action?.payload?.success,

                isFirstLoad: false,
            };

        case GET_NEW_TRADE_PAIR_ERROR:
            return { newTradePairLoading: false, newTradePairData: null, newTradePairError: action?.payload, newTradePairStatus: action?.payload?.success, isFirstLoad: false, };
        case UPDATE_NEW_TRADE_PAIR_DATA:
            return {
                ...state,
                newTradePairData: {
                    ...state.newTradePairData,
                    result: {
                        ...state.newTradePairData.result,
                        ...action.payload,
                    },
                },
            };
        case REMOVE_NEW_TRADE_PAIR:
            return { ...state, newTradePairData: null, newTradePairError: null, isModified: false, newTradePairStatus: null, isFirstLoad: true, newTradePairLoading: false }
        default:
            return state;
    }
};

export default NewTradePairReducer;